import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import CuteCountdown from "../Countdown/CuteCountdown";

import RSVPForm from "../Story/RSVPForm";

import mehendiBg from "../../assets/events/mehendi-bg.png";
import haldiBg from "../../assets/events/haldi-bg.png";
import sangeetBg from "../../assets/events/sangeet-bg.png";
import weddingBg from "../../assets/events/wedding-bg.png";
import pellikuthuruBg from "../../assets/events/pellikuthuru-bg.png";
import pellikodukuBg from "../../assets/events/pellikoduku-bg.png";

import "./RSVPPage.css";

/*
 * This SVG lives inside:
 *
 * public/event-stickers/disco-ball.svg
 *
 * Do NOT import it from src.
 */
const discoBall = "/event-stickers/disco-ball.svg";

const events = [
  {
    id: "mehendi",
    number: "01",

    title: "Tales in Henna",
    ceremony: "Mehendi",

    date: "November 19",
    year: "2026",
    time: "6:00 PM",

    theme: "Bright Colors",

    venue: "DeSoto",
    address: "2 Gatewood Dr, DeSoto, TX 75115, USA",
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=2%20Gatewood%20Dr%2C%20DeSoto%2C%20TX%2075115%2C%20USA",

    note:
      "Henna-stained hands, bright colors and stories waiting to be written.",

    invitation:
      "Come begin the celebrations with an evening of henna, music, laughter and every color we could possibly fit into one beautiful night.",

    image: mehendiBg,
    icon: "✿",
    animation: "mehendi",
    previewPosition: "center",
    className: "destinyMehendi",
  },

  {
    id: "sangeet",
    number: "02",

    title: "Dancing into Forever",
    ceremony: "Cocktail",

    date: "November 20",
    year: "2026",
    time: "6:00 PM",

    theme: "Blingy & Glam",

    venue: "Prism",
    address: "350 E Royal Ln Ste 123, Irving, TX 75039",
    mapUrl:
      "https://share.google/L2g4lRpdn0blAIG72",

    note:
      "Turn up the sparkle. We're dancing our way into forever.",

    invitation:
      "The lights come on, the music gets louder and our favorite people take over the dance floor. Bring your sparkle and your best moves.",

    image: sangeetBg,
    icon: "🥂",
    animation: "sangeet",
    className: "destinySangeet",
    previewPosition: "center 22%",
  },

  {
    id: "haldi",
    number: "03",

    title: "Hues of Sunshine",
    ceremony: "Haldi",

    date: "November 21",
    year: "2026",
    time: "10:00 AM",

    theme: "Pastels",

    venue: "DeSoto",
    address: "2 Gatewood Dr, DeSoto, TX 75115, USA",
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=2%20Gatewood%20Dr%2C%20DeSoto%2C%20TX%2075115%2C%20USA",

    note:
      "A morning dipped in sunshine, pastels and a little happy chaos.",

    invitation:
      "Come paint the morning with us, soft pastels, sunshine, laughter and all the joyful chaos that makes Haldi unforgettable.",

    image: haldiBg,
    icon: "☀",
    animation: "haldi",
    className: "destinyHaldi",
    previewPosition: "center",
  },

  {
    id: "pellikuthuru",
    number: "04",

    title: "Bride's Chapter",
    ceremony: "Pellikuthuru",

    date: "November 21",
    year: "2026",
    time: "7:00 PM",

    theme: "Traditional",

     venue: "DeSoto",
     address: "2 Gatewood Dr, DeSoto, TX 75115, USA",
     mapUrl:
         "https://www.google.com/maps/search/?api=1&query=2%20Gatewood%20Dr%2C%20DeSoto%2C%20TX%2075115%2C%20USA",

    note:
      "A beautiful chapter filled with blessings, tradition and the bride surrounded by family.",

    invitation:
      "An evening close to our hearts, filled with traditions, family blessings and the beautiful rituals that prepare the bride for the wedding day.",

    image: pellikuthuruBg,

    icon: "♡",

    animation: "pelli",

    className: "destinyPelli",
    previewPosition: "center 30%",
  },

  {
    id: "pellikoduku",
    number: "05",

    title: "Groom's Chapter",
    ceremony: "Pellikoduku",

    date: "November 21",
    year: "2026",
    time: "7:00 PM",

    theme: "Traditional",

    venue: "TBD",
    address: "TBD",
    mapUrl: null,

    note:
      "A chapter of traditions, laughter and blessings for the groom.",

    invitation:
      "An evening filled with traditions, family blessings and the rituals that prepare the groom for the beautiful day ahead.",

    image: pellikodukuBg,

    icon: "♡",

    animation: "pelli",

    className: "destinyPelli",
    previewPosition: "center 25%",
  },

  {
    id: "wedding",
    number: "06",

    title: "Beginning of Forever",
    ceremony: "The Wedding",

    date: "November 22",
    year: "2026",
    time: "Starts: 9:30AM & Muhurtham : 10:29AM",

    theme: "Traditional Elegance",

    venue: "Firefly Gardens",
    address: "5410 US-287, Midlothian, TX 76065",
    mapUrl:
      "https://share.google/YzuOd2oz2XsCrqzae",

    note:
      "And just like that, destiny becomes forever.",

    invitation:
      "The chapter we've been waiting for. With our families beside us and the people we love around us, we begin forever.",

    image: weddingBg,
    icon: "∞",
    animation: "wedding",
    className: "destinyWedding",
    previewPosition: "center",
  },
];

/* =========================================================
   EVENT ON MAIN TIMELINE
   ========================================================= */

function DestinyEvent({ event, index, onOpen }) {
  const reverse = index % 2 !== 0;

  return (
    <motion.article
      className={`destinyEvent ${
        reverse ? "destinyReverse" : ""
      } ${event.className}`}
      initial={{
        opacity: 0,
        y: 65,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
        amount: 0.2,
      }}
      transition={{
        duration: 0.7,
      }}
    >
      {/* SCRAPBOOK IMAGE */}

      <motion.button
        type="button"
        className="destinyPicture"
        onClick={() => onOpen(event)}
        whileHover={{
          y: -8,
          rotate: reverse ? 1.2 : -1.2,
        }}
        whileTap={{
          scale: 0.98,
        }}
      >
        <span className="destinyTape" />

        <div className={`archPeekCard archPeek-${event.id}`}>
          <span className="archPeekFlower archFlowerOne">
            ✿
          </span>

          <span className="archPeekFlower archFlowerTwo">
            ❀
          </span>

          <div className="archPeekFrame">
            <div className="archPeekWindow">
              <img
                src={event.image}
                alt=""
                aria-hidden="true"
                style={{
                  objectPosition:
                    event.previewPosition || "center",
                }}
              />
            </div>
          </div>

          <div className="archPeekHint">
            peek inside
            <span>♡</span>
          </div>

          <span className="archTinyOrnament">
            ✦
          </span>
        </div>

        <span className="pictureCaption">
          {event.ceremony}
        </span>

        <span className="pictureCorner">
          {event.icon}
        </span>
      </motion.button>

      {/* DESTINY THREAD NUMBER */}

      <div className="destinyCenter">
        <motion.div
          className="destinyMarker"
          whileInView={{
            scale: [0.7, 1.15, 1],
          }}
          viewport={{
            once: true,
          }}
        >
          <span>{event.number}</span>
        </motion.div>
      </div>

      {/* EVENT WORDING */}

      <div className="destinyWords">
        <span className="destinyCeremony">
          {event.ceremony}
        </span>

        <h3>{event.title}</h3>

        <p className="destinyNote">
          {event.note}
        </p>

        <div className="destinyQuickInfo">
          <span>{event.date}</span>

          <i>♡</i>

          <span>{event.time}</span>
        </div>

        <button
          type="button"
          className="discoverEvent"
          onClick={() => onOpen(event)}
        >
          unwrap this chapter
          <span>↗</span>
        </button>
      </div>
    </motion.article>
  );
}

/* =========================================================
   ANIMATIONS INSIDE OPENED EVENT
   ========================================================= */

function AnimatedEventStickers({ event }) {
  /* =======================================================
     MEHENDI
     No hands sticker.
     Only light flowers + tiny sparkle.
     ======================================================= */

  if (event.animation === "mehendi") {
    const flowers = ["✿", "❀", "✿", "❀", "✿", "❀"];

    const sparkles = ["✦", "♡", "✦", "♡"];

    return (
      <div className="eventStickerLayer mehendiStickerLayer">
        {flowers.map((flower, index) => (
          <motion.span
            key={`mehendi-flower-${index}`}
            className={`mehendiFloatingFlower mehendiFlower${
              index + 1
            }`}
            initial={{
              y: -40,
              opacity: 0,
            }}
            animate={{
              y: [-40, 620],

              x: [
                0,
                index % 2 === 0
                  ? 28
                  : -28,
              ],

              rotate: [0, 180, 360],

              opacity: [
                0,
                0.75,
                0.75,
                0,
              ],
            }}
            transition={{
              duration: 6 + index * 0.45,
              delay: index * 0.65,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {flower}
          </motion.span>
        ))}

        {sparkles.map((spark, index) => (
          <motion.span
            key={`mehendi-spark-${index}`}
            className={`hennaSpark hennaSpark${
              index + 1
            }`}
            animate={{
              opacity: [0.15, 0.9, 0.15],
              scale: [0.7, 1.25, 0.7],
            }}
            transition={{
              duration: 1.6 + index * 0.25,
              delay: index * 0.35,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            {spark}
          </motion.span>
        ))}
      </div>
    );
  }

  /* =======================================================
     SANGEET
     Disco balls + sparkles + moving light
     ======================================================= */

  if (event.animation === "sangeet") {
    const balls = [
      {
        className: "partyBall ballOne",
        delay: 0,
        duration: 3.2,
      },
      {
        className: "partyBall ballTwo",
        delay: 0.12,
        duration: 2.8,
      },
      {
        className: "partyBall ballThree",
        delay: 0.24,
        duration: 3.6,
      },
      {
        className: "partyBall ballFour",
        delay: 0.36,
        duration: 3,
      },
      {
        className: "partyBall ballFive",
        delay: 0.48,
        duration: 3.4,
      },
    ];

    const sparkles = [
      "✦",
      "✧",
      "⋆",
      "✦",
      "✧",
      "⋆",
      "✦",
      "✧",
      "✦",
      "⋆",
      "✧",
      "✦",
    ];

    return (
      <div className="eventStickerLayer sangeetStickerLayer">
        {/* GLOWS */}

        <motion.div
          className="sangeetGlow sangeetGlowOne"
          animate={{
            opacity: [0.12, 0.48, 0.12],
            scale: [0.9, 1.15, 0.9],
          }}
          transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        <motion.div
          className="sangeetGlow sangeetGlowTwo"
          animate={{
            opacity: [0.08, 0.4, 0.08],
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0.5,
          }}
        />

        {/* DISCO BALLS */}

        {balls.map((ball, index) => (
          <motion.div
            key={`party-ball-${index}`}
            className={ball.className}
            initial={{
              opacity: 0,
              y: -100,
            }}
            animate={{
              opacity: 1,
              y: 0,

              rotate:
                index % 2 === 0
                  ? [-6, 6, -6]
                  : [6, -6, 6],
            }}
            transition={{
              opacity: {
                duration: 0.45,
                delay: ball.delay,
              },

              y: {
                duration: 0.7,
                delay: ball.delay,
                ease: "easeOut",
              },

              rotate: {
                duration: ball.duration,
                repeat: Infinity,
                ease: "easeInOut",
              },
            }}
          >
            <img
              src={discoBall}
              alt=""
            />
          </motion.div>
        ))}

        {/* GLITTER */}

        {sparkles.map((sparkle, index) => (
          <motion.span
            key={`sangeet-spark-${index}`}
            className={`sangeetSparkle sangeetSparkle${
              index + 1
            }`}
            animate={{
              opacity: [0.08, 1, 0.08],
              scale: [0.5, 1.4, 0.5],
              rotate: [0, 90, 180],
            }}
            transition={{
              duration: 1.2 + index * 0.1,
              delay: index * 0.1,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            {sparkle}
          </motion.span>
        ))}

        {/* LIGHT BEAMS */}

        <motion.div
          className="partyBeam partyBeamLeft"
          animate={{
            opacity: [0.06, 0.25, 0.06],
            rotate: [-12, 8, -12],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        <motion.div
          className="partyBeam partyBeamRight"
          animate={{
            opacity: [0.06, 0.22, 0.06],
            rotate: [12, -8, 12],
          }}
          transition={{
            duration: 4.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </div>
    );
  }

  /* =======================================================
     HALDI
     ======================================================= */

  if (event.animation === "haldi") {
    const particles = [
      "🌼",
      "✿",
      "●",
      "🌼",
      "✿",
      "●",
      "🌼",
    ];

    return (
      <div className="eventStickerLayer haldiStickerLayer">
        <motion.div
          className="haldiSunGlow"
          animate={{
            opacity: [0.08, 0.3, 0.08],
            scale: [0.9, 1.12, 0.9],
          }}
          transition={{
            duration: 3.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {particles.map((item, index) => (
          <motion.span
            key={`haldi-${index}`}
            className={`haldiParticle haldiParticle${
              index + 1
            }`}
            initial={{
              y: -50,
              opacity: 0,
            }}
            animate={{
              y: [-50, 620],

              x: [
                0,
                index % 2 === 0
                  ? 30
                  : -30,
              ],

              rotate: [0, 360],

              opacity: [
                0,
                0.8,
                0.8,
                0,
              ],
            }}
            transition={{
              duration: 6 + index * 0.4,
              delay: index * 0.55,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {item}
          </motion.span>
        ))}
      </div>
    );
  }

  /* =======================================================
     PELLIKUTHURU / PELLIKODUKU
     White flowers only.
     ======================================================= */

  if (event.animation === "pelli") {
    const flowers = [
      {
        left: "8%",
        top: "16%",
        size: 30,
        delay: 0,
      },
      {
        left: "20%",
        top: "8%",
        size: 20,
        delay: 0.3,
      },
      {
        left: "36%",
        top: "20%",
        size: 25,
        delay: 0.6,
      },
      {
        left: "54%",
        top: "10%",
        size: 28,
        delay: 0.9,
      },
      {
        left: "72%",
        top: "18%",
        size: 22,
        delay: 1.2,
      },
      {
        left: "88%",
        top: "9%",
        size: 31,
        delay: 1.5,
      },
      {
        left: "12%",
        top: "48%",
        size: 23,
        delay: 1.8,
      },
      {
        left: "26%",
        top: "63%",
        size: 29,
        delay: 2.1,
      },
      {
        left: "44%",
        top: "52%",
        size: 20,
        delay: 2.4,
      },
      {
        left: "64%",
        top: "66%",
        size: 27,
        delay: 2.7,
      },
      {
        left: "80%",
        top: "49%",
        size: 21,
        delay: 3,
      },
      {
        left: "91%",
        top: "72%",
        size: 28,
        delay: 3.3,
      },
    ];

    return (
      <div className="eventStickerLayer pelliFlowerLayer">
        <motion.div
          className="pelliSoftGlow"
          animate={{
            opacity: [0.1, 0.3, 0.1],
            scale: [0.9, 1.12, 0.9],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* FLOWERS BLOOMING */}

        {flowers.map((flower, index) => (
          <motion.span
            key={`pelli-flower-${index}`}
            className="pelliWhiteFlower"
            style={{
              left: flower.left,
              top: flower.top,
              fontSize: flower.size,
            }}
            initial={{
              opacity: 0,
              scale: 0,
              rotate: -30,
            }}
            animate={{
              opacity: [
                0,
                0.95,
                0.95,
                0,
              ],

              scale: [
                0,
                1.25,
                1,
                0.85,
              ],

              rotate: [
                -30,
                8,
                -5,
                0,
              ],

              y: [5, -4, 0],
            }}
            transition={{
              duration: 4.5,
              delay: flower.delay,
              repeat: Infinity,
              repeatDelay: 1.2,
              ease: "easeInOut",
            }}
          >
            ❀
          </motion.span>
        ))}

        {/* LIGHT PETALS */}

        {Array.from({
          length: 8,
        }).map((_, index) => (
          <motion.span
            key={`pelli-petal-${index}`}
            className={`pelliWhitePetal pelliWhitePetal${
              index + 1
            }`}
            animate={{
              opacity: [0, 0.7, 0],

              y: [-40, 570],

              x: [
                0,
                index % 2 === 0
                  ? 22
                  : -22,
              ],

              rotate: [0, 220],
            }}
            transition={{
              duration: 7 + index * 0.4,
              delay: index * 0.65,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            ❀
          </motion.span>
        ))}
      </div>
    );
  }

  /* =======================================================
     WEDDING
     ======================================================= */

  if (event.animation === "wedding") {
    const blessings = [
      "✦",
      "❀",
      "✦",
      "❀",
      "✦",
      "❀",
      "✦",
    ];

    return (
      <div className="eventStickerLayer weddingStickerLayer">
        <motion.div
          className="weddingGlow"
          animate={{
            opacity: [0.1, 0.35, 0.1],
            scale: [0.9, 1.12, 0.9],
          }}
          transition={{
            duration: 3.7,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {blessings.map((item, index) => (
          <motion.span
            key={`wedding-${index}`}
            className={`weddingBlessing weddingBlessing${
              index + 1
            }`}
            initial={{
              y: -40,
              opacity: 0,
            }}
            animate={{
              y: [-40, 620],

              x: [
                0,
                index % 2 === 0
                  ? 24
                  : -24,
              ],

              rotate: [0, 220],

              opacity: [
                0,
                0.8,
                0,
              ],
            }}
            transition={{
              duration: 6 + index * 0.45,
              delay: index * 0.55,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {item}
          </motion.span>
        ))}
      </div>
    );
  }

  return null;
}

/* =========================================================
   OPENED EVENT
   ========================================================= */

function EventStory({ event, onClose }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    const handleEscape = (keyboardEvent) => {
      if (keyboardEvent.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener(
      "keydown",
      handleEscape
    );

    return () => {
      document.body.style.overflow = "";

      window.removeEventListener(
        "keydown",
        handleEscape
      );
    };
  }, [onClose]);

  return (
    <motion.div
      className="eventStoryOverlay"
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
      onClick={onClose}
    >
      <motion.div
        className={`eventStory ${event.className}`}
        initial={{
          scale: 0.94,
          opacity: 0,
          y: 30,
        }}
        animate={{
          scale: 1,
          opacity: 1,
          y: 0,
        }}
        exit={{
          scale: 0.96,
          opacity: 0,
          y: 20,
        }}
        transition={{
          duration: 0.4,
        }}
        onClick={(clickEvent) =>
          clickEvent.stopPropagation()
        }
      >
        <button
          type="button"
          className="eventStoryClose"
          onClick={onClose}
          aria-label="Close event"
        >
          ×
        </button>

        {/* LEFT */}

        <div className="eventStoryArtwork">
          <div className="artworkPaper">

             <img
                className="eventArtworkBackdrop"
                src={event.image}
                alt=""
                aria-hidden="true"
              />

            <img
              className="eventMainArtwork"
              src={event.image}
              alt={event.ceremony}
            />

            <AnimatedEventStickers
              event={event}
            />
          </div>

          <motion.span
            className="storyDoodle doodleOne"
            animate={{
              rotate: [-7, 6, -7],
              y: [0, -9, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            {event.icon}
          </motion.span>

          <motion.span
            className="storyDoodle doodleTwo"
            animate={{
              rotate: [6, -5, 6],
              y: [0, 8, 0],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            ♡
          </motion.span>
        </div>

        {/* RIGHT */}

        <div className="eventStoryDetails">
          <p className="storyChapter">
            chapter {event.number}
          </p>

          <p className="storyCeremony">
            {event.ceremony}
          </p>

          <h2>{event.title}</h2>

          <p className="storyInvitation">
            {event.invitation}
          </p>

          <div className="storyInfoStrip">
            <div>
              <small>date</small>

              <strong>{event.date}</strong>

              <span>{event.year}</span>
            </div>

            <div>
              <small>time</small>

              <strong>{event.time}</strong>
            </div>

            <div>
              <small>dress mood</small>

              <strong>{event.theme}</strong>
            </div>

           <div className="storyVenueCard">
             <small>where</small>

             <strong>{event.venue}</strong>

             <span>{event.address}</span>

             {event.mapUrl && (
               <a
                 href={event.mapUrl}
                 target="_blank"
                 rel="noreferrer"
                 className="storyMapLink"
               >
                 View on Google Maps
                 <span>↗</span>
               </a>
             )}
           </div>
           </div>

          <div className="storyEnding">
            <div />

            <p>
              save some smiles,
              <br />
              we'll make the memories.
            </p>

            <span>♡</span>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}

/* =========================================================
   PAGE
   ========================================================= */

export default function RSVPPage({
  onBack,
  onOpenStory,
}) {
  const [activeEvent, setActiveEvent] =
    useState(null);

  return (
    <main className="rsvpExperiencePage">
      {/* HERO */}

      <section className="destinyHero">
        <motion.div
          className="destinyHeroContent"
          initial={{
            opacity: 0,
            y: 35,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.8,
          }}
        >
          <p>Anjan & Sahana</p>

          <h1>
            Come
            <span>Celebrate</span>
            With Us
          </h1>

          <div className="destinyHeroLine">
            <span>✦</span>
            <div />
            <span>♡</span>
            <div />
            <span>✦</span>
          </div>

          <CuteCountdown variant="rsvp" />

          <div className="destinyHeroActions">
            <button
              type="button"
              onClick={onBack}
            >
              ← Home
            </button>

            <button
              type="button"
              onClick={onOpenStory}
            >
              Our Story →
            </button>
          </div>
        </motion.div>
      </section>

      {/* TIMELINE */}

      <section className="destinyJourney">
        <div className="journeyHeading">
          <span>
            november · 2026
          </span>

          <h2>
            Five little chapters
            <br />
            before forever
          </h2>

          <p>
            Touch a memory to unfold
            the celebration.
          </p>
        </div>

        <div className="destinyTimeline">
          <div className="destinyThread">
            <span className="threadHeart">
              ♡
            </span>
          </div>

          {events.map(
            (event, index) => (
              <DestinyEvent
                key={event.id}
                event={event}
                index={index}
                onOpen={setActiveEvent}
              />
            )
          )}

          <div className="timelineEnding">
            <span>♥</span>

            <p>
              ...and then,
              <br />
              forever.
            </p>
          </div>
        </div>

        <motion.button
          type="button"
          className="destinyRsvpButton"
          whileHover={{
            y: -4,
          }}
          whileTap={{
            scale: 0.97,
          }}
          onClick={() =>
            document
              .getElementById(
                "rsvp-section"
              )
              ?.scrollIntoView({
                behavior: "smooth",
              })
          }
        >
          <span>
            Will you be there?
          </span>

          RSVP with love ♡
        </motion.button>
      </section>

      {/* RSVP */}

      <div id="rsvp-section">
        <RSVPForm />
      </div>

      {/* OPEN EVENT */}

      <AnimatePresence>
        {activeEvent && (
          <EventStory
            event={activeEvent}
            onClose={() =>
              setActiveEvent(null)
            }
          />
        )}
      </AnimatePresence>
    </main>
  );
}